import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CRMFilterOverride, ObjectType } from '@galaxy/crm/static';
import { isAcceptedObjectType } from '../../validators';
import { ScoringDefinitionService } from '../scoring-definition.service';

@Pipe({
  name: 'filterOverride',
  standalone: true,
})
export class FilterOverridePipe implements PipeTransform {
  private readonly scoringDefinitionService = inject(ScoringDefinitionService);

  transform(fieldId?: string, objectType?: ObjectType): Observable<CRMFilterOverride | undefined> {
    if (!fieldId || !isAcceptedObjectType(objectType)) {
      return of(undefined);
    }
    return this.scoringDefinitionService.getFilterOverride(fieldId, objectType);
  }
}
